import axios from 'axios';

let baseURL = 'https://indiefy.net/v1/';

if (location.href.includes('localhost')) {
  baseURL = 'http://localhost:3000/v1/';
}

// Create axios instance with base configuration
const api = axios.create({
  baseURL: baseURL,
  withCredentials: true, // Required for all API calls
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Note: We removed the mock data to use the actual analytics service

// Response interceptor for handling common errors
api.interceptors.response.use(
  response => response,
  error => {
    // Handle specific error cases here
    if (error.response) {
      // Server responded with a status code outside of 2xx range
      if (error.response.status === 401) {
        // Unauthorized - could handle auth token expiration here
        console.warn('Unauthorized API request:', error.config.url);

        // Check if we're already on the login page to avoid redirect loops
        const currentPath = window.location.pathname;
        if (!currentPath.includes('/auth/login')) {
          // Only log the error, don't redirect here to avoid conflicts with router guards
          console.log('Authentication required - router guard will handle redirect');
        }
      } else if (error.response.status === 403) {
        console.warn('Forbidden API request:', error.config.url);
      } else if (error.response.status === 404) {
        console.warn('Resource not found:', error.config.url);
      } else if (error.response.status >= 500) {
        console.error('Server error:', error.response.status, error.config.url);
      }
    } else if (error.request) {
      // The request was made but no response was received
      console.error('Network Error - no response received:', error.config?.url || 'unknown endpoint');
    } else {
      // Something happened in setting up the request
      console.error('API Request Error:', error.message);
    }
    return Promise.reject(error);
  },
);

export default api;